import React from "react";
import {Route} from "react-router-dom";
import {VariationList, ProductShow, ProductList} from "../../views/marketplace/retailer/product/index";
import RequireAuthentication from "../../hoc/authentication/requireAuthentication";
import RetailerLoader from "../../hoc/retailer/retailerLoader";
import EnrichmentPage from "../../views/marketplace/enrichment";
import {Authorizations, hasAuthorization} from "../../utils/authorizations";
import {sessionStore} from "../../utils/sessionStore";

let routes = [];
const applications = sessionStore.get("applications");
const authorizations = sessionStore.get("authorizations") ?? [];

if (applications && applications["marketplace"]) {
    if (hasAuthorization(authorizations, Authorizations.MARKETPLACE_PRODUCT_VIEW) || hasAuthorization(authorizations, Authorizations.MARKETPLACE_PRODUCT_EDIT) || hasAuthorization(authorizations, Authorizations.MARKETPLACE_PRODUCT_MANAGEMENT)) {
        routes.push([
            <Route
                path="/retailers/show/:id/products/variations/:params"
                component={RequireAuthentication(RetailerLoader(VariationList))}
                exact
                strict
                key="variationList"
            />,
            <Route
                path="/retailers/show/:id/products/:params"
                component={RequireAuthentication(RetailerLoader(ProductList))}
                exact
                strict
                key="list"
            />,
        ])
    }

    if (hasAuthorization(authorizations, Authorizations.MARKETPLACE_PRODUCT_ENRICH)) {
        routes.push([
            <Route
                path="/retailers/show/:id/enrichment"
                component={RequireAuthentication(RetailerLoader(EnrichmentPage))}
                exact
                key="retailerEnrichment"
            />,
        ])
    }

    if (hasAuthorization(authorizations, Authorizations.MARKETPLACE_PRODUCT_MANAGEMENT) || hasAuthorization(authorizations, Authorizations.MARKETPLACE_PRODUCT_EDIT)) {
        routes.push([
            <Route
                path="/retailers/show/:id/products/show/:prid"
                component={RequireAuthentication(RetailerLoader(ProductShow))}
                exact
                strict
                key="productShow"
            />,
            <Route
                path="/retailers/show/:id/products/show/:prid/variation/:vrid"
                component={RequireAuthentication(RetailerLoader(ProductShow))}
                exact
                strict
                key="variationShow"
            />,
        ])
    }
}

export default routes;
